// extracted by mini-css-extract-plugin
module.exports = {"paper":"styles_paper__1Um7L","spin":"styles_spin__2WYgb"};